import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";

import { SocialShare } from "@quintype/components";
import { SocialShareTemplate } from "../../../../arrow";
import { SvgIconHandler } from "../../../../components/atoms/SvgIconHandler";
import { useDeviceType } from "../../../../components/customHooks/useDeviceType";
import { ALLOWED_SOCIAL_HANDLES } from "../../../../constants";
import AuthorImage from "../../Atoms/AuthorImage";
import ListingAdSlot from "../../../../components/molecules/ListingAdSlot";

import "./author-intro.m.css";

const AuthorIntroductionCard = ({ data = {}, template = "" }) => {
  const { name, bio, social, metadata } = data;
  const bioRef = useRef(null);
  const deviceType = useDeviceType();
  const isDesktop = deviceType === "desktop";
  const [readMoreClicked, setReadMoreClicked] = useState(false);
  const [shareLink, setShareLink] = useState("");
  const getIcon = (item) => {
    switch (item) {
      case "twitter":
        return "follow-x";
      case "facebook":
        return "follow-facebook";
      case "instagram":
        return "follow-instagram";
      default:
        break;
    }
  };

  const expandBio = () => setReadMoreClicked(true);

  useEffect(() => {
    setShareLink(window.location.href);
  }, []);

  const [readMoreVisible, setReadMoreVisible] = useState(false);

  useEffect(() => {
    if (window.innerWidth < 768 && bioRef.current) {
      const bioHeight = window?.getComputedStyle(bioRef.current);
      const getLineHeight = parseFloat(bioHeight.lineHeight);
      const lineHeightForThree = getLineHeight * 3;
      bioRef.current.style.height = `${lineHeightForThree}px`;
      bioRef.current.style.overflow = "hidden";
      if (bioRef.current.scrollHeight > bioRef.current.clientHeight) {
        setReadMoreVisible(true);
      }

      if (readMoreClicked) {
        bioRef.current.style.display = `block`;
        bioRef.current.style.height = `fit-content`;
      }
    }
    return () => {
      if (bioRef?.current) {
        bioRef.current.style.overflow = "visible";
      }
    };
  }, [readMoreClicked, isDesktop]);

  const socialHandles = () => {
    return ALLOWED_SOCIAL_HANDLES.map((item, index) => {
      if (social[item]?.url) {
        return (
          <a
            data-test-id="social-link"
            href={social[item].url}
            key={`${item}-${index}`}
            rel="noopener noreferrer nofollow"
            target="_blank"
            styleName="social-share"
          >
            <SvgIconHandler width="28" height="28" viewBox={`0 0 28 28`} type={getIcon(item)} />
          </a>
        );
      }
    });
  };

  return (
    <div className="author-intro-wrapper-width-ad">
      <div
        data-test-id="author-intro"
        className="full-width-with-padding arrow-component arr--author-intro-card"
        styleName="default"
      >
        <div className="arrow-author-intro-wrapper">
          <div styleName="introduction-card" className="arrow-author-introduction-card">
            <div styleName="author-details">
              <h1>{name}</h1>
              {metadata?.designation && <div className="designation">{metadata?.designation}</div>}
              <div styleName="social-connect-wrapper">{social && socialHandles()}</div>
            </div>

            <div styleName="social-wrapper" className="social-wrapper">
              <span className="content-style">
                <SocialShare
                  popupText="Share this URL"
                  template={SocialShareTemplate}
                  eventName="dl_author_detail_interactions"
                  fullUrl={encodeURI(shareLink)}
                  title={`${name} on Open Magazine`}
                  shareText
                  shareIconId={`share-icon-company-share`}
                />
              </span>
            </div>
          </div>
          <div className="arrow-author-image">
            <AuthorImage author={data} template={template} isClickable={false} />
          </div>
        </div>
        {bio && (
          <div style={{ position: "relative" }}>
            <div data-test-id="author-bio" className="author-bio" styleName="clamped-text" ref={bioRef}>
              {bio}
            </div>
            {!readMoreClicked && !isDesktop && readMoreVisible && (
              <button onClick={expandBio} styleName="read-more">
                Read More
              </button>
            )}
          </div>
        )}
      </div>
      <div styleName="ad-slot">
        <ListingAdSlot
          adStyleName="ad-slot-size-300x250"
          adType="intro_card"
          pageType="author-page"
          adSlotConfigName="mRec_ad"
        />
      </div>
    </div>
  );
};

AuthorIntroductionCard.propTypes = {
  data: PropTypes.shape({ name: PropTypes.string, bio: PropTypes.string, social: PropTypes.object }),
  template: PropTypes.string,
};
export default AuthorIntroductionCard;
